// Pagination control for the admin list pages. Extracted from
// AdminAudits.jsx (W2d). Same Prev/Next labels, same data-testid contract
// (`testIdPrefix` lets the consumer keep page-specific test-ids).
//
// Defaults retain the AdminAudits prefix so existing Playwright selectors
// (`audits-page-prev`, `audits-page-next`, `admin-audits-pager`) continue
// to work without changes.
export default function AdminPager({
  page,
  totalPages,
  onPrev,
  onNext,
  testIdRoot = "admin-audits-pager",
  testIdPrev = "audits-page-prev",
  testIdNext = "audits-page-next",
}) {
  return (
    <div
      style={{ display: "flex", gap: 8, marginTop: 16, alignItems: "center", justifyContent: "flex-end" }}
      data-testid={testIdRoot}
    >
      <button
        type="button"
        className="sf-btn-secondary"
        disabled={page <= 1}
        onClick={onPrev}
        data-testid={testIdPrev}
      >
        ← Prev
      </button>
      <span className="sf-mono sf-muted-text" style={{ fontSize: 12 }}>Page {page} / {totalPages}</span>
      <button
        type="button"
        className="sf-btn-secondary"
        disabled={page >= totalPages}
        onClick={onNext}
        data-testid={testIdNext}
      >
        Next →
      </button>
    </div>
  );
}
